import React, {useEffect, useState} from "react";
import {useUser} from "@/contexts/UserContext";
import {useInfoBox} from "@/commons/infoBox/InfoBox";
import Redirects from "@/commons/utils/Redirects";
import BaseInfoBoxs from "@/commons/infoBox/BaseInfoBoxs";
import {getSubDomain} from "@/commons/utils/Domains";

import flame from "@/commons/resources/images/logos/fiamma.png";
import style from "./PageManager.module.css";

const PageManager = () => {
    const {addInfo} = useInfoBox();
    const {isLogged, isStaff, userLoadingComplete} = useUser();
    const [pageLoaded, setPageLoaded] = useState(false);

    useEffect(() => {
        if (!userLoadingComplete) return;

        checkPage();
        checkPopUpData();
        setPageLoaded(true);
        if(window.location.pathname.toLowerCase() === "/loading")
            setPageLoaded(false);
    }, [userLoadingComplete]);

    function checkPage() {
        const page = window.location.pathname.replace("/", "");
        const pageDomain = getSubDomain(window.location.hostname);

        const loggedPages = ["profile"];
        const notLoggedPages = ["access"];
        const loggedDomains = ["reports", "reportsdev"];
        const AdminDomains = ["panel", "admin", "admindev"];

        if (!isLogged) {
            if (loggedDomains.includes(pageDomain) || AdminDomains.includes(pageDomain) || loggedPages.includes(page)) {
                Redirects.domainSend("www", "", {popupData: BaseInfoBoxs("notLogged")});
            }
        } else {
            if (notLoggedPages.includes(page)) {
                Redirects.send("/", null, {popupData: BaseInfoBoxs("alreadyLogged")});
            }
            if (AdminDomains.includes(pageDomain) && !isStaff) {
                Redirects.domainSend("www", "", {popupData: BaseInfoBoxs("pageAccessDenied")});
            }
        }
    }

    function checkPopUpData() {
        const url = new URL(window.location.href);
        const popupDataValues = url.searchParams.getAll('popupData');

        popupDataValues.forEach((popupData) => {
            if (!popupData) return;
            const decodedString = atob(popupData);
            const json = JSON.parse(decodedString);
            addInfo(json.type, json.title, json.text, json.time);
            url.searchParams.delete('popupData');
            window.history.replaceState({}, '', url);
        });
    }

    return (
        <>
            {!pageLoaded && (
                <div className={style.loadingPage}>
                    <div className={style.loadingContent}>
                        <div className={style.loadingBox}>
                            <img src={flame} alt="Logo" className={style.logoCenter}/>
                            <span className={style.loadingCircle}></span>
                        </div>
                        <h1 className={style.loadingText}>EBLCraft in<br/>Caricamento…</h1>
                    </div>
                </div>
            )}
        </>
    );
};

export default PageManager;